export default __webpack_public_path__ + "static/media/wechat-concat-01.78940bb6.jpg";